import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=a5e85a10&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=a5e85a10&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e85a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5e85a10')) {
      api.createRecord('a5e85a10', component.options)
    } else {
      api.reload('a5e85a10', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=a5e85a10&scoped=true&", function () {
      api.rerender('a5e85a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kLsG0xsWzD89/JS/comp/Paginate.vue"
export default component.exports